<template>
  <div class="halloween-spider">
    <div v-for="side in 2" :key="side" class="spider-legs" :class="{ lower: side === 2 }">
      <span v-for="leg in 4" :key="leg" class="spider-leg" :style="{ '--leg': leg }" />
    </div>
    <div class="spider-body" />
    <div class="spider-head"><span /><span /></div>
  </div>
</template>

<style scoped lang="scss">
.halloween-spider {
  position: relative;
  width: 90px;
  height: 90px;
  color: #211b29;
  filter: drop-shadow(0 3px 2px #0005) drop-shadow(0 0 1px #fff9);
  animation: spider-scuttle 0.12s ease-in-out infinite alternate;
}

.spider-body {
  position: absolute;
  left: 23px;
  top: 32px;
  width: 36px;
  height: 26px;
  border-radius: 50%;
  background: currentColor;
}

.spider-head {
  position: absolute;
  left: 53px;
  top: 35px;
  width: 22px;
  height: 20px;
  border-radius: 50%;
  background: currentColor;

  span {
    position: absolute;
    right: 5px;
    top: 4px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #f5a524;

    + span {
      top: 12px;
    }
  }
}

.spider-legs {
  position: absolute;
  inset: 0;

  &.lower {
    transform: scaleY(-1);
  }
}

.spider-leg {
  position: absolute;
  left: calc(20px + var(--leg) * 8px);
  top: 16px;
  width: 23px;
  height: 29px;
  border-top: 3px solid currentColor;
  border-left: 3px solid currentColor;
  border-radius: 6px 0 0;
  transform-origin: bottom right;
  rotate: calc((var(--leg) - 2.5) * 27deg);
  animation: spider-step 0.16s ease-in-out infinite alternate;
  animation-delay: calc(var(--leg) * -0.08s);
}

@keyframes spider-step {
  to {
    transform: rotate(18deg);
  }
}

@keyframes spider-scuttle {
  to {
    transform: translateY(2px);
  }
}
</style>
